export function getEnvironmentFromHost(): "local" | "dev" | "staging" | "prod" {
  const hostParts = window.location.host.split(".");

  if (hostParts[1] === "localhost:8000") {
    return "local";
  } else if (hostParts[1] === "dev") {
    return "dev";
  } else if (hostParts[1] === "staging") {
    return "staging";
  } else {
    return "prod";
  }
}
